(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-collection"] && !Shopify.designMode) return;
  try {
    
  /* QA-ONLY (remove before launch): ?hw_full=1 unlocks Horizon's .page-wrapper for full-page desktop screenshots */
  if (/[?&]hw_full=1/.test(location.search)) { var hwst = document.createElement('style'); hwst.textContent = '#shopify-pc__banner{display:none!important}html,body,.page-wrapper{height:auto!important;overflow:visible!important}'; document.head.appendChild(hwst); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-header"] && !Shopify.designMode) return;
  try {
    
  // HW header: close the phone menu on outside tap / Escape
  (function () {
    if (window.__hwHm) return; window.__hwHm = 1;
    // phone menu + desktop Learn more: one open at a time; close on outside tap, link tap or Escape
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-hw-menu][open]').forEach(function (d) { if (!d.contains(e.target) || e.target.closest('a')) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-hw-menu][open]').forEach(function (d) { d.open = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-page-sci-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.hwpSciGo) return;
    window.hwpSciGo = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sci-go]');
      if (!b) return;
      var t = document.getElementById(b.getAttribute('data-sci-go'));
      if (!t) return;
      e.preventDefault();
      var cite = t.classList.contains('sci-cite');
      t.scrollIntoView({ behavior: 'smooth', block: cite ? 'center' : 'start' });
      if (cite) { t.classList.add('sci-hl'); setTimeout(function () { t.classList.remove('sci-hl'); }, 1800); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-page-support"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.hwpTrackOn) return;
    window.hwpTrackOn = true;
    var loading = null;
    function load17() {
      if (window.YQV5) return Promise.resolve();
      if (loading) return loading;
      loading = new Promise(function (ok, no) {
        var sc = document.createElement('script');
        sc.src = 'https://www.17track.net/externalcall.js';
        sc.onload = ok; sc.onerror = no;
        document.head.appendChild(sc);
      });
      return loading;
    }
    document.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('form[data-hwp-track]');
      if (!f) return;
      var num = (f.querySelector('input[name="nums"]').value || '').replace(/\s+/g, '');
      if (!num) return;
      var box = document.getElementById(f.getAttribute('data-hwp-track'));
      e.preventDefault();
      load17().then(function () {
        if (!window.YQV5 || !box) { window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener'); return; }
        box.hidden = false;
        window.YQV5.trackSingle({ YQ_ContainerId: box.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num });
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }).catch(function () { window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener'); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
